import { render, staticRenderFns } from "./AppGridDropdown.vue?vue&type=template&id=04e84cd7&scoped=true&"
import script from "./AppGridDropdown.vue?vue&type=script&lang=js&"
export * from "./AppGridDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e84cd7",
  null
  
)

export default component.exports